import React from "react";
import { Reveal, MaskedLines } from "./Reveal";

// Reusable editorial header for interior pages
export default function PageHeader({ eyebrow, titleLines, subtitle, image, imageAlt = "", chapter }) {
  return (
    <section className="relative pt-20 md:pt-24 pb-12 md:pb-16 border-b border-stone-800 glow-gold">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-7">
          {chapter && (
            <p className="chapter-num text-[56px] md:text-[72px] leading-none mb-3">
              {chapter}
            </p>
          )}
          {eyebrow && (
            <p data-testid="page-eyebrow" className="text-[11px] uppercase tracking-eyebrow text-[#D4AF37] mb-6">
              {eyebrow}
            </p>
          )}
          <MaskedLines
            testId="page-title"
            lines={titleLines}
            className="font-serif-display text-4xl md:text-5xl lg:text-7xl leading-[1.02] tracking-tight text-stone-50"
          />
          {subtitle && (
            <Reveal delay={0.35}>
              <p className="mt-5 max-w-2xl text-stone-300 text-base md:text-lg leading-relaxed">
                {subtitle}
              </p>
            </Reveal>
          )}
        </div>

        {image && (
          <Reveal delay={0.2} className="lg:col-span-5">
            <div className="relative aspect-[4/3] w-full overflow-hidden">
              <img
                src={image}
                alt={imageAlt}
                className="w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/70 via-transparent to-transparent" />
              <div className="absolute inset-0 ring-1 ring-inset ring-stone-100/10" />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}

